(function () {
    'use strict';

    angular
        .module('app')
        .factory('PromiseLatest', PromiseLatestFactory);

    PromiseLatestFactory.$inject = ['$q'];

    function PromiseLatestFactory($q) {
        function PromiseLatest() {
            this.latestOnly = latestOnly;

            var latestPromise = null;

            /**
             * Transform a promise into a promise that only resolves/rejects if it's
             * the most recently provided promise in the container.
             * This is useful when UI actions might cause multiple simultaneous requests
             * to fetch data, e.g. changing pages in a grid.
             * If the user quickly clicks from one page to another, the last result
             * may not necessarily correspond to the last UI event.
             *
             * Use it like this:
             *
             * var container = new PromiseLatest();
             *
             * container.latestOnly(Service.getData(inputs)).then(processData);
             * container.latestOnly(Service.getData(inputs)).then(processData);
             * container.latestOnly(Service.getData(inputs)).then(processData); // This is the only one that will trigger the 'then' handler.
             *
             *
             * @param {promise}
             * @returns {promise}
             */
            function latestOnly(promise) {
                var defer = $q.defer();

                latestPromise = promise;
                
                promise.then(function ok(response) {
                    if (promise === latestPromise) {
                        defer.resolve(response);
                    }
                }, function error(response) {
                    if (promise === latestPromise) {
                        defer.reject(response);
                    }
                });

                return defer.promise;
            }
        }

        return PromiseLatest;
    }
})();